import { connect } from 'react-redux';
import LoadingContainer from './LoadingContainer';

const mapStateToProps = ({ auth, scoreCard }) => ({
    isAuthenticated: auth.isAuthenticated,
    isSignedIn: auth.isSignedIn,
    enabled: scoreCard.enabled,
    user: auth.user
});

export default connect(mapStateToProps)(LoadingContainer);
